import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { ShieldCheck, Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!email.trim() || !password) { toast.error("Enter your email and password."); return; }
    setLoading(true);
    try {
      await api.post("/auth/admin-login", { email: email.trim(), password });
      toast.success("Signed in.");
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invalid email or password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F6F3EC] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="h-7 w-7 bg-[#0A0A0A] flex items-center justify-center rounded-sm"><ShieldCheck className="h-4 w-4 text-white" /></div>
          <span className="font-display text-xl font-bold tracking-tight">FIAD Administrator</span>
        </div>
        <div className="bg-white border border-[#E5E5E5] rounded-sm p-6">
          <div className="inline-flex items-center gap-2 text-[#525252] mb-4"><Lock className="h-4 w-4" /><span className="text-xs font-medium uppercase tracking-wider">Secure sign in</span></div>
          <label className="block text-sm font-medium mb-1.5">Email</label>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-[#E5E5E5] rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black" />
          <label className="block text-sm font-medium mb-1.5 mt-4">Password</label>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-[#E5E5E5] rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black" />
          <button data-testid="admin-login-btn" type="submit" disabled={loading} className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-white px-5 py-3 rounded-sm text-sm font-medium hover:bg-[#262626] disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </div>
        <p className="mt-4 text-center text-xs text-[#A3A3A3]">FIAD administrator access only.</p>
      </form>
    </div>
  );
}
